// RFC 2822 standard email validation
// to allow + based emails
// https://www.w3resource.com/javascript/form/email-validation.php#:~:text=RFC%202822%20standard%20email%20validation
/* eslint-disable no-control-regex */
const VALID_EMAIL_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const validateEmail = (email: string, allowedDomains?: string[]) => {
  const isValidEmail = VALID_EMAIL_REGEX.test(email);
  const emailDomain = '@' + email.split('@')[1];

  const isAllowedDomain = allowedDomains
    ? allowedDomains.includes(emailDomain)
    : true;

  return {
    isValid: isValidEmail && isAllowedDomain,
    isValidEmail,
    isAllowedDomain,
  };
};
